import axios from '@/libs/api.request'

// 获取广告点击的列表
export const apiAdClickList = (data) => {
  return axios.request({
    url: `/ad-click`,
    method:'get',
    data
  })
}

